export default __webpack_public_path__ + "static/flipping-misfits-6f62120e8bdbd99d354ec147c83a6d2c.jpg";